import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NightModeService } from './night-mode.service';
import { SettingService } from './settings.service';
import { MsgInfoService } from './msg-info.service';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private token: string | null = null;
  subs = new Array();

  constructor(
    private http: HttpClient,
    private router: Router,
    private nightModeService: NightModeService,
    private settingService: SettingService,
    private msgInfo: MsgInfoService
  ) { }



  refreshToken() {
    let token = this.getToken();

    let headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    })
    return this.http.post(`${environment.apiUrl}/api/Login/refresh`, {}, { headers });
  }

  setToken(token: string) {
    this.token = token;
    sessionStorage.setItem("6f4r86n41dvcq4f6a15q7fvqsdfvs66c51cc", token);
    let params = this.getTokenParameters();
    this.nightModeService.setNightMode(params["DARK_MODE"] === "1");

  }
  getToken() {
    if (!this.token) {
      this.token = sessionStorage.getItem("6f4r86n41dvcq4f6a15q7fvqsdfvs66c51cc");
    }
    return this.token;
  }
  getTokenId() {
    let decoded: any = jwtDecode(this.getToken() || '');
    return decoded.id || null;
  }
  getTokenParameters() {
    let decoded: any = jwtDecode(this.getToken() || '');
    let ret: any = {}
    if (decoded.parameter) {
      let params = JSON.parse(decoded.parameter) || [];
      params.forEach((el: any) => {
        ret[el.key] = el.value;
      });
      return ret
    }
    return {}
  }
  clearToken() {
    sessionStorage.removeItem("6f4r86n41dvcq4f6a15q7fvqsdfvs66c51cc")
  }

  getUserRole() {
    let token: any = this.getToken();
    let decodedToken: any = jwtDecode(token);
    return decodedToken['Role'].replace("_" + environment.establishment, "");
  }


  login(login: string, password: string): Observable<any> {

    return this.http.post(`${environment.apiUrl}/api/Login`, {
      login: login,
      password: password,
      idEstablishement: environment.establishment,
      mode: 1,
    });
  }

  setRouteByUser() {
    const user = this.getUserRole();
    if (user == "DIRECTEUR") {
      return {
        liste_url: ['admin', 'loge', 'staff', 'cantine', 'intendance', 'maintenance'],
        default_url: 'admin'
      }
    }
    else if (user == "CPE") {
      return {
        liste_url: ['admin', 'loge', 'staff', 'cantine'],
        default_url: 'admin'
      }
    }
    else {
      return '';
    }
  }

  returnConnectionRouteByRole() {
    const user = this.getUserRole();

    if (user === 'DIRECTEUR') {
      return 'admin';
    }
    else if (user === 'CPE') {
      return 'admin';
    }
    else if (user === 'SURVEILLANT') {
      return 'staff';
    }
    else if (user === 'INTERVENANT') {
      return 'staff';
    }
    else if (user === 'LOGE') {
      return 'loge';
    }
    else if (user === 'CANTINE') {
      return 'cantine';
    }
    else if (user === 'INTENDANT') {
      return 'intendance';
    }
    else if (user === 'MAINTENANCE') {
      return 'maintenance';
    }
    else {
      this.msgInfo.updateInfo({ msg: "Rôle inconnu, merci de contacter le support", duration: 3000 });
      return 'login';
    }
  }


  getTokenExpirationDate(token: string): any {
    const decoded: any = jwtDecode(token);
    if (decoded.exp === undefined) {
      return null;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }
  userHasAccessToTicket() {
    const role = this.getUserRole();
    const params = this.getTokenParameters();
    const roles = params.TICK_ALL_RL.replace('[', '').replace(']', '').split(',');

    if (roles.includes(role)) {
      return true
    } else if (role == 'DIRECTEUR' || role == 'INTENDANT' || role == 'MAINTENANCE') {
      return true
    } else {
      return false;
    }

  }
  isTokenExpired(token: string): boolean {
    if (!token) {
      return true;
    }

    const date = this.getTokenExpirationDate(token);
    if (date === undefined) {
      return false;
    }
    return !(date.valueOf() > new Date().valueOf());
  }

  getDefaultURL() {
    return decodeURIComponent(this.getTokenParameters()["DEFAULT_PAGE"]) || '';
  }
  clearDefaultURL() {
    const id = this.getTokenId();
    const key = "DEFAULT_PAGE";
    const value = "none";

    this.settingService.updateSettingsStaff(key, value, id).subscribe((res: any) => {
    })
  }
  ngOnDestroy() {
    for (let k in this.subs) {
      this.subs[k].unsubscribe();
    }
  }
}
